// extracted by mini-css-extract-plugin
module.exports = {"article":"InsuranceDetailArticleWrapper_article__4ZMrI","expired":"InsuranceDetailArticleWrapper_expired__FfQu5"};